// import library
import axios from "axios";
import { useTranslation } from "react-i18next";
// import component
import Layout from "../../layouts/Layout";
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
// files
import { env } from "../../env";
import LoaderIcon from "../../components/Common/Icon/Loader";
import AssetFormPopUpComponent from "../../components/Profile/AssetFormPopUpComponent";

const EditAsset = () => {
    // variables
    const { t } = useTranslation();
    const { id, customerId } = useParams();
    const [isLoader, setIsLoader] = useState(true);

    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [currentAsset, setCurrentAsset] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [conditionList, setConditionList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            getStatusListApi(baseUrl, token);
            getConditionListApi(baseUrl, token);

            // loader here
            getDefaultProductImage(baseUrl, token);
            getAssetDetailApi(baseUrl, token);
        };
        fetchData();
    }, []);

    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getAssetDetailApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        await axios.get(url+`${`/api/Assets/GetAllAssignedAssetsById?_id=${id}`}`,{ headers })
        .then((response) => {
            setIsLoader(false);
            if(response.data.length > 0) {
                const result = conditionList.find(condition => condition.Id === response.data[0].Condition_id);
                if(result) {
                    response.data[0].conditionTitle = result.Title;
                } else {
                    response.data[0].conditionTitle = "";
                }
                setCurrentAsset(response.data[0]);
            }
        }).catch((error) => {
            console.log(error);
            setIsLoader(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getStatusListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Assets/GetStatusList`,{ headers })
        .then((response) => {
            setStatusList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getConditionListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Assets/GetAssetConditions`,{ headers })
        .then((response) => {
            setConditionList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleModalCloseDataFromChild = (data) => {
        if(data === "updated") {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');
            getAssetDetailApi(baseUrl, token);
        }
    };
    
    return (
        <div className="relative">
            <Layout>
                <div className="flex justify-between items-center">
                    <div className="w-44 sm:w-auto">
                        <h1 className="text-sm sm:text-2xl font-semibold capitalize">{ t('asset details') }</h1>
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center cursor-pointer"><NavLink to='/profiles'>{ t('profile') }</NavLink> / <NavLink to={`/profiles/detail/${customerId}`}>{ t('customer detail') }</NavLink> / { t('update asset detail') }</div>
                    </div>
                    <NavLink to={`/profiles/detail/${customerId}`}>
                        <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                            <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                        </div>
                    </NavLink>
                </div>
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                        <AssetFormPopUpComponent defaultProductImage={defaultProductImage} sendModalCloseDataFromChild={handleModalCloseDataFromChild} currentAsset={currentAsset} statusList={statusList} conditionList={conditionList}/>
                }
            </Layout>
        </div>
    )
}

export default EditAsset;